import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import 'vue-search-select/dist/VueSearchSelect.css'
import './plugins/fontawesome'
import './plugins/bootstrap-vue'
import './plugins/vue-moment'
import './plugins/vue-socket.io'
import './plugins/dateFormatFilter'
import vSelect from 'vue-select';
import './registerServiceWorker'
import VueClipboards from 'vue-clipboards';

Vue.use(Vuelidate);
Vue.use(VueClipboards);

Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
